import script from "./InviteNewUser.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteNewUser.vue?vue&type=script&setup=true&lang=js"

import "./InviteNewUser.vue?vue&type=style&index=0&id=e91dc2d6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e91dc2d6"]])

export default __exports__